<template>
  <svg viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.078125 20.4557V11.565H7.74893C9.96126 11.565 10.933 11.6478 12.5044 11.8752L12.6698 11.3583C11.2225 10.6553 10.5402 10.3245 9.40301 9.68353L8.70002 9.29069V0.027832L25.9231 15.2661V16.6927L8.70002 31.9723V22.7508L9.40301 22.3579C10.5402 21.717 11.2225 21.3655 12.6698 20.6832L12.5044 20.1663C10.933 20.3937 9.96126 20.4557 7.74893 20.4557H0.078125Z"
      fill="currentColor"
    />
  </svg>
</template>
